<template>
  <div class="score-card">
    <div v-if="shotsLoading && !userShots" class="progress">
      <pulse-loader :color="loaderColor" :size="loaderSize"></pulse-loader>
    </div>

    <!-- <div v-else-if="!userShotsLoading && userShots" class="flex-around"> -->
    <div v-else class="flex-around">
      <div v-if="hasHoleScores" class="flex flex-column item-column">
        <div v-if="hasHoleScores" :class="[itemHeaderClass, 'hole-header-background']">Hole</div>
        <div
          v-if="hasHoleHandicaps"
          :class="`${itemHeaderClass} ${$vuetify.theme.dark ? '' : 'item-handicap'}`"
        >
          Handicap
        </div>
        <div v-if="hasHolePars" :class="`${itemHeaderClass} item-par`">Par</div>

        <!-- Scramble Team scores -->
        <div v-for="(i, x) in scrambleTeamsTotal" :key="`6${i}`">
          <transition v-if="isScramble" name="fadeDown" mode="out-in" appear>
            <div :class="`${itemHeaderClass} ${$vuetify.theme.dark ? '' : 'item-score'}`">
              Team
              {{
                scrambleTeamScores[x] && scrambleTeamScores[x].team
                  ? parseInt(scrambleTeamScores[x].team) + 1
                  : 'N/A'
              }}
              <!-- {{ parseInt(scrambleTeamScores[x].team) + 1 }} -->
              <!-- <span v-show="scrambleTeamScores[x].teamPlayers">
                ({{ scrambleTeamScores[x].teamPlayers }})
              </span> -->
            </div>
          </transition>
        </div>

        <!-- Score -->
        <transition v-if="!isScramble && !isBestBall" name="fadeDown" mode="out-in" appear>
          <div
            v-if="hasHoleScores"
            :class="`${itemHeaderClass} ${$vuetify.theme.dark ? '' : 'item-score'}`"
          >
            Score
          </div>
        </transition>
        <!-- net -->
        <transition v-if="!isScramble && !isBestBall" name="fadeDown" mode="out-in" appear>
          <div v-if="hasHoleNetScores" :class="[itemHeaderClass, 'item-round-score']">
            Net<span
              v-if="!isScramble && userShots && userShots.handicap"
              class="caption1 font-weight-light"
            >
              (HCP {{ userShots.handicap | utility_toFixedOneDecimal | utility_handicapFormat }})
            </span>
          </div>
        </transition>
        <!-- To Par / Round Score -->
        <transition v-if="!isScramble && !isBestBall" name="fadeDown" mode="out-in" appear>
          <div v-if="hasHoleRoundScores" :class="[itemHeaderClass, 'item-round-score']">
            Round Score
          </div>
        </transition>
        <!-- Best Ball Team Score -->
        <transition v-if="isBestBall" name="fadeDown" mode="out-in" appear>
          <div v-if="hasBestBallScores" :class="[itemHeaderClass, 'item-score']">Team Score</div>
        </transition>
        <div
          v-if="hasTeeClubs && !isScramble && !isBestBall"
          :class="[itemHeaderClass, 'divider-header-background']"
        >
          Club
        </div>
        <div v-if="hasFairwayShots && !isScramble && !isBestBall" :class="[itemHeaderClass]">
          Fairways
        </div>
        <div v-if="hasSandShots && !isScramble && !isBestBall" :class="[itemHeaderClass]">
          Sand Save
        </div>
        <div
          v-if="hasGreensInRegulation && !isScramble && !isBestBall"
          :class="[itemHeaderClass, 'divider-header-background']"
        >
          GIR
        </div>
        <div
          v-if="expanded && hasPuttingShots && !isScramble && !isBestBall"
          :class="[itemHeaderClass, 'item-putt']"
        >
          Putts
        </div>
        <div
          v-if="expanded && hasMulligans && !isScramble && !isBestBall"
          :class="[itemHeaderClass]"
        >
          Mulligans
        </div>
        <div
          v-if="expanded && hasPenalties && !isScramble && !isBestBall"
          :class="[itemHeaderClass]"
        >
          Penalties
        </div>
      </div>

      <ScoreCardItem
        v-for="(hole, i) in userShots.holeNumber"
        :key="i"
        :user-shot-data="userShots"
        :hole="hole"
        :index="i"
        :expanded="expanded"
        :game-mode="gameMode"
        class="flex flex-column front"
      />

      <!-- <ScoreCardItemTotal
        v-if="userShots"
        header="out"
        :userShotData="userShots"
        :begin="0"
        :end="9"
        :expanded="expanded"
        :gameMode="gameMode"
      /> -->

      <!-- <ScoreCardItem
        v-for="(hole, i) in 9"
        :userShotData="userShots"
        :hole="hole + 9"
        :index="i + 9"
        :key="i + 9"
        :expanded="expanded"
        :gameMode="gameMode"
        class="flex flex-column back"
      /> -->

      <!-- <ScoreCardItemTotal
        v-if="hasHoleScores"
        header="in"
        :userShotData="userShots"
        :begin="9"
        :end="holeScoreLength"
        :expanded="expanded"
        :gameMode="gameMode"
      /> -->

      <ScoreCardItemTotal
        v-if="hasHoleScores"
        header="total"
        :user-shot-data="userShots"
        :begin="0"
        :end="holeScoreLength"
        :expanded="expanded"
        :game-mode="gameMode"
      />
    </div>

    <!-- Scorecard Legend -->
    <div v-if="!userShotsLoading" class="flex-row">
      <div
        :class="`legend legend-header-background text-xs-left ${expanded ? 'bottom-border' : null}
          ${$vuetify.theme.dark ? 'legend-dark' : null}`"
      >
        <ul class="flex-end">
          <li>
            <span class="eagle pl-1 pr-1">&nbsp;</span>
            Eagle&#43;
          </li>
          <li>
            <span class="birdie pl-1 pr-1">&nbsp;</span>
            Birdie
          </li>
          <li>
            <span class="par pl-1 pr-1">&nbsp;</span>
            Par
          </li>
          <li>
            <span class="bogey pl-1 pr-1">&nbsp;</span>
            Bogey
          </li>
          <li>
            <span class="double-bogey pl-1 pr-1">&nbsp;</span>
            Double Bogey
          </li>
          <li>
            <span class="triple-bogey pl-1 pr-1">&nbsp;</span>
            Triple Bogey&#43;
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ScoreCardItem from '@/components/ScoreCardItemV3';
import ScoreCardItemTotal from '@/components/ScoreCardItemTotalV3';
import utilityMixin from '@/mixins/utilityMixin';

export default {
  name: 'ScoreCard',

  components: {
    ScoreCardItem,
    ScoreCardItemTotal,
  },

  filters: {
    percentage(v) {
      if (v) return `${(v * 100).toFixed(1)}%`;
      return `${v}%`;
    },
  },
  mixins: [utilityMixin],
  props: {
    pars: Array,
    scores: Array,
    golfer: Object,
    courseHoles: Array,
    userShots: Object,
    shotsLoading: Boolean,
    expanded: Boolean,
    gameMode: String,
  },

  data() {
    return {
      userShotsLoading: false,
      loaderColor: '#BA2127',
      loaderSize: '1em',
    };
  },

  computed: {
    itemHeaderClass() {
      return 'item header text-left';
    },

    isBestBall() {
      return this.gameMode?.toLowerCase().replace('_', '') === 'bestball';
    },

    hasBestBallScores() {
      return this.userShots?.bestBallTeamScores?.length > 0;
    },

    isScramble() {
      return this.gameMode?.toLowerCase() === 'scramble';
    },

    scrambleTeamsTotal() {
      return this.userShots?.scrambleTeamScores?.length;
    },

    scrambleTeamScores() {
      const { scrambleTeamScores } = this.userShots;
      return scrambleTeamScores;
    },

    hasHoleScores() {
      // console.log('this.userShots:', this.userShots);
      return !!this.userShots?.holeScores;
    },

    hasHoleHandicaps() {
      return !!this.userShots?.holeHandicaps;
    },

    hasHolePars() {
      return !!this.userShots?.holePars;
    },

    hasHoleNetScores() {
      const hasNetScoreValue = this.userShots?.holeNetScores.some((value) => {
        return value !== null && value !== undefined;
      });
      // return !!this.userShots?.holeRoundScores;
      return hasNetScoreValue;
    },

    hasHoleRoundScores() {
      const hasRoundScoreValue = this.userShots?.holeRoundScores.some((value) => {
        return value !== null && value !== undefined;
      });
      // return !!this.userShots?.holeRoundScores;
      return hasRoundScoreValue;
    },

    hasTeeClubs() {
      return !!this.userShots?.teeClubs;
    },

    hasFairwayShots() {
      return !!this.userShots?.fairwayShots;
    },

    hasSandShots() {
      return !!this.userShots?.sandShots;
    },

    hasGreensInRegulation() {
      return !!this.userShots?.greensInRegulation;
    },

    hasPuttingShots() {
      return !!this.userShots?.puttingShots;
    },

    hasMulligans() {
      return !!this.userShots?.mulligans;
    },

    hasPenalties() {
      return !!this.userShots?.penalties;
    },

    holeScoreLength() {
      if (this.userShots?.holeScores) {
        return this.userShots.holeScores.length;
      }
    },
  },

  watch: {
    //   golfer: {
    //     handler(newVal, oldVal) {
    //       this.pollingHandler = setInterval(() => {
    //         this.polling = true;
    //         this.$emit('polling', this.polling);
    //         let cacheBust;
    //         const browser = browserDetector();
    //         browser === 'IE 11' ? (cacheBust = `/?cb=${Date.now()}`) : (cacheBust = '');
    //         this.$store.dispatch('shots/all', `${this.golfer.round_uuid}${cacheBust}`).then(res => {
    //           this.polling = false;
    //           this.$emit('polling', this.polling);
    //         });
    //       }, 7000);
    //     },
    //     immediate: true,
    //   },
    // userShots: {
    //   handler(newVal, oldVal) {
    //     console.log('oldVal:', oldVal);
    //     console.log('newVal:', newVal);
    //   },
    //   immediate: true,
    // },
  },

  // mounted() {
  //   console.log('userShots:', this.userShots);
  // },

  beforeDestroy() {
    this.$store.dispatch('shots/resetState');
  },

  methods: {},
};
</script>

<style scoped>
.score-card {
  width: 100%;
  font-size: 0.875rem;
}

.flex {
  display: flex;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.flex-around {
  display: flex;
  justify-content: space-around;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
}

.item {
  padding: 16px;
  padding-right: 8px;
  text-align: center;
  width: 100%;
  line-height: 0;
}

.item-score {
  background-color: var(--offWhite);
}

.item-putt,
.item-par {
  border-bottom: 1px solid #6d6d6d;
  border-bottom: 1px solid var(--grey);
}

.item-round-score {
  border-top: 1px solid #6d6d6d;
  border-top: 1px solid var(--grey);
}

.item-handicap {
  background-color: var(--offWhite);
}

.item-column > .item {
  border-left: none;
}

.header {
  font-weight: 600;
  padding-top: 16px;
  padding-bottom: 16px;
  margin-right: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-background {
  background-color: rgba(0, 0, 0, 0.1);
}

.hole-header-background {
  background-color: var(--grey);
  color: var(--white);
}

.divider-header-background {
  background-color: var(--grey-light);
  color: var(--white);
}

.legend-header-background {
  background-color: var(--grey-lightest);
}

.legend {
  font-size: 0.5625rem;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 10px;
  width: 100%;
}

.legend-dark {
  color: var(--offBlack);
}

.legend > ul {
  list-style-type: none;
}

.legend > ul > li {
  display: inline;
  margin-left: 15px;
}

.legend > ul > li > span {
  margin-right: 2px;
}

.bottom-border {
  border-bottom: 2px solid #6d6d6d;
  border-bottom: 2px solid var(--grey);
}

.par {
  background-color: var(--offWhite);
  color: var(--offBlack);
}

.birdie {
  background-color: var(--primary);
  color: var(--white);
}

.eagle,
.under-eagle {
  background-color: var(--yellow);
  color: var(--offBlack);
}

.double-eagle {
  background-color: var(--green);
  color: var(--white);
}

.in-play {
  background-color: var(--orange-lightest);
  color: var(--offBlack);
}

.bogey {
  background-color: var(--blue);
  color: var(--white);
}

.double-bogey {
  background-color: var(--grey);
  color: var(--white);
}

.triple-bogey,
.over-bogey {
  background-color: var(--grey-darker);
  color: var(--white);
}

.bad {
  background-color: var(--black);
  color: var(--white);
}

.over {
  background-color: #f7b90d;
}

.under {
  background-color: #69abde;
}

.progress {
  position: relative;
  min-height: 85px;
  width: 60px;
  margin: 0 auto;
}

.progress > div {
  position: absolute;
  top: 35px;
  right: 0vw;
}

@media screen and (max-width: 1024px) {
  .scorecard-container {
    overflow: auto;
  }

  .flex-around {
    display: flex;
    justify-content: flex-start;
  }

  .flex-end {
    display: flex;
    justify-content: flex-end;
  }
}

@media screen and (max-width: 960px) {
  .score-card {
    width: auto;
  }

  .item {
    padding: 8px;
  }

  .legend {
    padding: 10px;
  }
}
</style>

<style>
.container.grid-list-md .layout .score-card .flex {
  padding: 0;
}

.container.grid-list-md .layout .score-card {
  padding-left: 4px;
  padding-right: 4px;
}
</style>
